import type { AppRouteRecordRaw } from '@/router/types'

export const clueHighSeasManageRoutes: AppRouteRecordRaw[] = [
  {
    path: 'clueHighSeasManage',
    name: 'ClueHighSeasManage',
    component: () => import('@/views/clueHighSeasManage/index.vue'),
    meta: { title: '线索公海', keepAlive: true }
  },
  {
    path: 'clueHighSeasDetail',
    name: 'ClueHighSeasDetail',
    component: () => import('@/views/clueHighSeasManage/clueHighSeasDetail/index.vue'),
    meta: { title: '线索公海详情' }
  }
]
